import { render, staticRenderFns } from "./ContentLoading.vue?vue&type=template&id=17ed8b38"
import script from "./ContentLoading.vue?vue&type=script&lang=js"
export * from "./ContentLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports